import React, { CSSProperties, useCallback, useMemo } from 'react';
import { MentionsInput, Mention } from 'react-mentions';
import classes from './style.module.scss';
import { useStoreActions, useStoreState } from '~/store';
import { debounce } from 'lodash';

type SuggestionEntry = {
  id: string | number;
  display: string;
  [key: string]: any;
};

type MentionsTextAreaProps = {
  value: string;
  onChange: (event: any, newValue: string) => void;
  placeholder?: string;
  className?: string;
  style?: CSSProperties | undefined;
  embedded?: boolean;
};

export type MentionsTextAreaComponent = React.FC<MentionsTextAreaProps>;

const MentionsTextArea: MentionsTextAreaComponent = ({ value, onChange, placeholder, className, style, embedded }) => {

  const userId = useStoreState(state => state.user.data.id);
  const fetchSearchUser = useStoreActions(actions => actions.user.fetchSearchUser);

  const debouncedFetchUsers = useMemo(() => {
    return debounce((query: string, callback: (results: any[]) => void) => {
      fetchSearchUser({ searchText: query, offset: 0, isForTag: true })
        .then(res => res.map(user => ({ display: user.name, avatar: user.avatar, id: user.id })).filter(user => Number(user.id) !== Number(userId)))
        .then(callback)
        .catch(() => callback([]));
    }, 500);
  }, [fetchSearchUser, userId]);

  const fetchUsers = useCallback((query: string, callback: (results: any[]) => void) => {
    debouncedFetchUsers(query, callback);
  }, [debouncedFetchUsers]);

  return (
    <div style={style} className={`${className} ${embedded ? classes['mentions-embedded'] : ''}`}>
      <MentionsInput
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        classNames={classes}
        className={'mentions'}
        allowSpaceInQuery
      >
        <Mention
          data={fetchUsers}
          className={classes.mentions__mention}
          renderSuggestion={(suggestion: SuggestionEntry, _search: string, highlightedDisplay: JSX.Element, _index: number, _focused: boolean) => (
            <div className={classes.custom__mention}>
              <img src={suggestion.avatar} alt={suggestion.display} />
              {highlightedDisplay}
            </div>
          )}
        />
      </MentionsInput>
    </div>
  );

};

export default MentionsTextArea;
